<template>
	<div :class="['labelElement', options.wrapperClass]">
		<label :class="['label', options.className]">
			<span>{{ options.label }}</span>
			<span :class="[options.innerClass]">{{ computedGetter | toCurrency }}</span>
		</label>
	</div>
</template>

<script>
import shared from '@/mixins/shared';
import _ from 'lodash';

export default {
	mixins: [shared],
	computed: {
		computedGetter() {
			return this.$store.getters[this.options.getter];
		},
	},
};
</script>
